import { ActionCreator } from "redux";
import {
	ActionType,
	InquiryListDateRangeChangedAction,
	InquiryListHighlightedInquiryChangedAction,
	ArchivedInquiriesUpdatedAction,
	ArchivedInquiriesViewToggledAction
} from "./type";

export const changeInquiryListDateRange: ActionCreator<
	InquiryListDateRangeChangedAction
> = (startDate: Date, endDate: Date) => ({
	type: ActionType.InquiryListDateRangeChanged,
	payload: {
		startDate,
		endDate
	}
});

export const changeHighlightedInquiry: ActionCreator<
	InquiryListHighlightedInquiryChangedAction
> = (id: string) => ({
	type: ActionType.InquiryListHighlightedInquiryChanged,
	payload: {
		id
	}
});

export const toggleArchiveVisibility: ActionCreator<ArchivedInquiriesViewToggledAction> = (state: boolean) => ({
	type: ActionType.AppArchivedInquiriesViewToggled,
	payload: {
		state
	}
});
